import { jsx } from 'react/jsx-runtime';
import { useRef, useEffect } from 'react';

var Sketch = function Sketch(_ref) {
  var sketch = _ref.sketch;
  var sketchRef = useRef(null);
  useEffect(function () {
    var p5 = require("p5");

    var canvas = new p5(sketch, sketchRef.current);
    return function () {
      canvas.remove();
    };
  }, [sketch]);
  return jsx("div", {
    ref: sketchRef
  }, void 0);
};

export { Sketch as default };
